module.exports = __webpack_public_path__ + "media/images/views/tech_client/so-logo-084fcd22e31ccd37eb2d2111353f002a.png";